import { render, staticRenderFns } from "./fieldRenameDlg.vue?vue&type=template&id=3c89cbec&scoped=true&"
import script from "./fieldRenameDlg.vue?vue&type=script&lang=js&"
export * from "./fieldRenameDlg.vue?vue&type=script&lang=js&"
import style0 from "./fieldRenameDlg.vue?vue&type=style&index=0&id=3c89cbec&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c89cbec",
  null
  
)

export default component.exports